/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.
*/

import { Subject } from "rxjs";
import { v4 } from "uuid";

export class CbDialogRef {
	public readonly id: string = v4();

	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	private _closeSubject: Subject<any> = new Subject<any>();

	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	public get onClose(): Subject<any> {
		return this._closeSubject;
	}

	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	public close(result?: any): void {
		this._closeSubject.next(result);
	}
}

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export class CbDialogConfig<T = any> {
	/**
	 * An object to pass to the component loaded inside the Dialog.
	 */
	public data?: T;

	/**
	 * Width of the dialog.
	 */
	public width?: string;

	/**
	 * Height of the dialog.
	 */
	public height?: string;

	/**
	 * Specifies if pressing escape key should hide the dialog.
	 */
	public closeOnEscape?: boolean = true;

	/**
	 * Specifies if clicking on the backdrop should hide the dialog.
	 */
	public closeOnBackdrop?: boolean = true;

	/**
	 * Position of the dialog, options are "center", "top", "bottom", "left", "right", "top-left", "top-right", "bottom-left" or "bottom-right".
	 */
	public position?: "center" | "top" | "bottom" | "left" | "right";

	/**
	 * The type of dialog
	 * modal: Opens a classic modal dialog in the position specified
	 * fullscreen: Opens a dialog that covers the entire screen, the animation and the content is managed by the used component
	 */
	public type?: "modal" | "fullscreen" = "modal";
}
